module.exports = __webpack_public_path__ + "img/euro-tax.pl.4ad7e5d5.svg";